(function () {
    'use strict';

    angular.module('vhols')
    
        .filter('yearFormatting', function() {
            return function(date) {
                if (date) {
                    return moment(date, 'YYYY-MM-DD').format('YYYY');
                }
                
                return '';
            };
        });
})();